

export function About() {
    return (
        <div id="about" className="section">
			<div className="container">

				<div className="row">

					<div className="col-md-6">
						<div className="section-header">
							<h2 className='h-title'>Welcome to VKC Trainings</h2>
							<hr className='title-hr'></hr>
							<div className='h-info'>
								<ul>
									<li>&nbsp;VKC Trainings Provide the best professional and real-time trainings. </li>
									<li>&nbsp;Build your carrier with strong technical skills and logical skills, here is the right place.</li>
									<li>&nbsp;Our strategic approaches helps to build your carrier and you every day you can find the difference in your skill set growth.</li>
								</ul>
							</div>
						</div>

						<div className="feature will-fadeIn">
							<i className="feature-icon fa fa-users"></i>
							<div className="feature-content">
								<h4>Offline & Online Courses </h4>
								<p>We provide online & offline trainings interactable Sessions. </p>
							</div>
						</div>

						<div className="feature will-fadeIn">
							<i className="feature-icon fa fa-laptop"></i>
							<div className="feature-content">
								<h4>Realtime Training</h4>
								<p>We provide in depth training with real time concepts and realtime project, daily taks and labs to build technical and logical skils.</p>
							</div>
						</div>

						<div className="feature will-fadeIn">
							<i className="feature-icon fa fa-shopping-bag"></i>
							<div className="feature-content">
								<h4>Placements</h4>
								<p>We provide training with placement assistance to start good carrier.</p>
							</div>
						</div>

						<div className="feature will-fadeIn">
							<i className="feature-icon fa fa-comments"></i>
							<div className="feature-content">
								<h4>Community</h4>
								<p>Our students are strength of our institute, we maintain community to grow.</p>
							</div>
						</div>

					</div>

					<div className="col-md-6">
						<div className="about-img">
							<img src= {require('../../../img/classgif.gif')}></img>
						</div>
					</div>

				</div>

			</div>
		</div>
    );
}